import styled, { css } from 'styled-components';
import { layout, styledUtils } from '@prisjakt/ui-base';
import ProductCheckbox, {
  PRODUCT_CHECKBOX_SIZE,
  productCheckboxHoverStyle,
} from '@prisjakt/ui-product-checkbox';
import { Link } from 'react-router-dom';

export const ProductLink = styled(Link)`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px 10px;
  outline: none;

  :hover::after,
  :focus::after {
    ${styledUtils.overlay()}
  }
`;

export const Row = styled.div.attrs({ 'data-test': 'ProductRow' })`
  position: relative;
  line-height: 1.2em;
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  ${props =>
    props.showDivider &&
    css`
      border-bottom: 1px solid ${p => p.theme.lines.primary};
    `}
  ${props =>
    props.selectable &&
    css`
      ${ProductLink} {
        padding-left: ${PRODUCT_CHECKBOX_SIZE + layout.spacing.values.small}px;
      }
    `}
  ${props =>
    props.selected &&
    css`
      ${ProductLink}::before {
        ${styledUtils.overlay(props.theme.bg.productCompareLight)}
      }
    `}

  .pj-ui-product-core-properties {
    margin: 0;
  }
`;

export const ProductImage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  background: ${p => p.theme.colors.base200};
  border-radius: ${layout.borderRadius};

  .pj-ui-product-image {
    display: block;
    max-width: 40px;
    max-height: 40px;
    width: auto;
    height: auto;
  }
`;

export const BasicInfo = styled.div`
  flex: 1 1 100%;
  margin-right: 3px;
`;

export const ProductName = styled.div`
  :not(:last-child) {
    margin-bottom: 1px;
  }
`;

export const Subtitle = styled.div`
  color: ${p => p.theme.text.tertiary};
  font-size: 12px;
`;

export const CampaignBadge = styled.span`
  padding: 5px;
  max-height: 55px;
  min-width: 21px;
  flex: 0 1 55px;
  margin-left: 10px;
  text-align: center;
`;

export const PriceLabelWrapper = styled.span`
  flex: 1 1 auto;
  margin-left: 10px;
  white-space: nowrap;
  text-align: right;
`;

export const StoreCount = styled.span`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: ${p => p.theme.text.tertiary};
  fill: ${p => p.theme.icons.tertiary};
  align-items: center;

  svg {
    height: 16px !important;
    width: 16px !important;
    margin-left: 2px;
  }
`;

export const Gutter = styled.span`
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

export const SelectBox = styled(ProductCheckbox)`
  position: absolute;
  left: ${layout.spacing.xSmall};
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  ${/* sc-selector */ Row}:hover & {
    ${productCheckboxHoverStyle}
  }
`;
